module.exports = __webpack_public_path__ + "img/SCB.de1fc9a6.png";